export default () => ({
  title: "PlaceNewDonationsOnHold",
  type: "object",
  properties: {
    value: {
      title: "Active",
      type: "boolean",
      default: false,
    },
  },
});
